<div class="dropdown-wrapper">
    <select class="form-control app-dropdown-select" [ngModel]="selectedValue" (ngModelChange)="onValueChange($event)"
        (change)="onNativeChange($event)" [disabled]="disabled" [class.disabled-select]="disabled">
        <option [ngValue]="null" disabled>{{ placeholder }}</option>
        <option *ngFor="let item of items" [ngValue]="item[valueField]">
            {{ item[displayField] }}
        </option>
    </select>
    <span class="dropdown-chevron">&#9662;</span>
</div>